import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, X } from "lucide-react";
import { HOME_ROUTE } from "../config/solutions";

/**
 * Shown when a member interacts with a solution they do not hold.
 *
 * Purely presentational: no API call, no permission check, no navigation into the locked
 * solution. Solution Access enforcement lives in the backend gate and the route guards;
 * this only explains the situation.
 *
 * @param solutionName  optional, e.g. "Revenue" — used in the heading copy
 * @param onClose       close handler
 */
export default function AccessRequiredModal({ solutionName, onClose }) {
  const navigate = useNavigate();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="access-required-title"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-xl bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between border-b border-gray-200 px-6 py-4">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-amber-50">
              <Lock className="h-4 w-4 text-amber-600" />
            </span>
            <h2 id="access-required-title" className="text-lg font-semibold text-gray-900">
              Access Required
            </h2>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="rounded-lg p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="px-6 py-5">
          <p className="text-sm leading-relaxed text-gray-600">
            You currently do not have access to
            {solutionName ? <span className="font-medium text-gray-900"> {solutionName}</span> : " this solution"}.
            Please contact your organization administrator to request access.
          </p>
        </div>

        <div className="flex justify-end gap-3 border-t border-gray-200 px-6 py-4">
          <button
            onClick={onClose}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Close
          </button>
          <button
            onClick={() => {
              onClose();
              navigate(HOME_ROUTE);
            }}
            className="rounded-lg bg-[#033F99] px-4 py-2 text-sm font-medium text-white hover:bg-[#022e73]"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
}
